import { Fragment, memo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useAtom } from 'jotai';
import { mutate } from 'swr';

import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import css from './GeoSelect.module.css';

import { dataApi } from 'services/DataService';
import { geoAtom } from 'v2/atoms/geoAtom';
import { Geo, geoToUIMap } from 'v2/constants';
import { Nullable } from 'v2/types';

export const GeoSelect = memo(() => {
  const [geo, setGeo] = useAtom(geoAtom);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);

  const handleGeoChange = (newGeo: Geo) => () => {
    setGeo(newGeo);
    setAnchorEl(null);
    mutate(() => true);
    dispatch(dataApi.util.resetApiState());
  };

  const { label, color } = geoToUIMap[geo];

  return (
    <Fragment>
      <Button
        className={css.geoSelectButton}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        startIcon={<Chip label={label} color={color} size="small" />}
      >
        Geo
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {Object.values(Geo).map((g) => (
          <MenuItem key={g} className={css.geoSelectMenuItem} selected={g === geo} onClick={handleGeoChange(g)}>
            <Chip label={geoToUIMap[g].label} color={geoToUIMap[g].color} size="small" />
            {geoToUIMap[g].label}
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  );
});

GeoSelect.displayName = 'GeoSelect';
